export default __webpack_public_path__ + "images/G4.fcdd7fd.jpg";